import { apiRequest } from '../apiRequest';

export const getTelegramDestinationsApi = async (page = 1, perPage = 15, query = '') => {
  let url = '/admin/notification/telegram-destinations?page=' + page + '&per_page=' + perPage;
  if (query) {
    url += '&query=' + encodeURIComponent(query);
  }

  return apiRequest(url, {
    method: 'GET',
    defaultErrorMessage: 'Failed to load Telegram destinations',
  });
};
